<template>
    <div class="fuite bg-gray-100 rounded-xl p-4 space-y-4 my-4">

        <!-- Titre + boutons -->
        <div class="flex items-center justify-between gap-2">
            <strong class="text-base font-semibold">Fuite {{ f.ordre }}</strong>

            <div class="flex items-center gap-2">
                <button
                    class="del-fuite inline-flex items-center justify-center bg-alert text-white rounded-lg px-3 py-1 text-sm transition"
                    @click.prevent="$emit('delFuite', [f.id])">
                    <i class="inline-block h-6 w-6 mask mask-trash bg-white"></i>

                </button>

                <button
                    class="photo inline-flex items-center justify-center bg-primary text-white rounded-lg px-3 py-1 text-sm hover:bg-primary/90 transition"
                    @click="triggerPhoto">
                    <i class="inline-block h-6 w-6 mask mask-photo bg-white"></i>

                </button>
            </div>

            <input type="file" accept="image/*" class="hidden" ref="inputfuite" @change="updatePhoto">
        </div>

        <!-- Photo -->
        <div v-if="urlPhoto(f)" class="w-full rounded-md overflow-hidden">
            <img :src="urlPhoto(f)" alt="photo fuite" class="w-full object-cover">
        </div>

        <!-- Localisation -->
        <textarea placeholder="Décrivez la localisation de la fuite" v-model="f.localisation" maxlength="255"
            @change="$emit('fuiteUpdated', f)" class="input w-full min-h-[70px] resize-y"></textarea>

        <!-- Réparation -->
        <div class="space-y-2 w-full">

            <p class="label">RÉPARATION DE LA FUITE</p>

            <!-- 2 radios côte à côte sur toute la largeur -->
            <div class="grid grid-cols-2 gap-3 w-full">

                <!-- Réparée -->
                <div>
                    <input type="radio" :id="f.id + '-reparation_ok'" :name="f.id + '-reparation'" :value="true"
                        v-model="f.reparation" @change="$emit('fuiteUpdated', f)" class="sr-only peer" />
                    <label :for="f.id + '-reparation_ok'" class="!text-sm block w-full rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   flex items-center justify-between
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow">
                        <span>RÉALISÉE</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

                <!-- À faire -->
                <div>
                    <input type="radio" :id="f.id + '-reparation_ko'" :name="f.id + '-reparation'" :value="false"
                        v-model="f.reparation" @change="$emit('fuiteUpdated', f)" class="sr-only peer" />
                    <label :for="f.id + '-reparation_ko'" class="!text-sm block w-full rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                   flex items-center justify-between
                   peer-checked:bg-vert peer-checked:text-white peer-checked:shadow">
                        <span>À FAIRE</span>
                        <i class="icon-valid opacity-0 peer-checked:opacity-100 transition"></i>
                    </label>
                </div>

            </div>
        </div>

    </div>
    </div>
</template>

<script>

import loadImage from 'blueimp-load-image'
import Config from '../../../../js/config'

export default {

    data() {
        return {
            f: this.fuite
        }
    },

    props: {
        fuite: {}
    },

    methods: {
        triggerPhoto() {
            this.$refs.inputfuite.click()
        },
        updatePhoto(e) {
            let vueInstance = this;

            loadImage(
                e.target.files[0],
                function (img) {
                    vueInstance.f.photo64 = img.toDataURL();
                    vueInstance.$emit('fuiteUpdated', vueInstance.f)
                },
                {
                    maxWidth: 600,
                    maxHeight: 600,
                    orientation: true,
                    canvas: true
                }
            )

        },

        urlPhoto(fuite) {

            if (typeof fuite.photo64 !== "undefined") {
                return fuite.photo64
            }

            const http = Config.urlAPI + '/upload';

            if (typeof fuite.photo !== "undefined") {
                return http + fuite.photo
            }

            return null;

        },
    }

}

</script>

<style>
a.del-fuite {
    background-color: #c31616;
}
</style>



// WEBPACK FOOTER //
// ItemFuite.vue?ca78ba8e